import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/root/.jenkins/workspace/47.102.216.211-loffice-frontend-dev/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import _typeof from "/root/.jenkins/workspace/47.102.216.211-loffice-frontend-dev/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [String, Number, Array, Boolean, Object],
      default: undefined
    },
    styleText: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // 自定义 value 字段名
    valueKey: {
      type: String,
      default: 'value'
    },
    // 自定义 label 字段名
    labelKey: {
      type: String,
      default: 'label'
    },
    reserveKeyword: {
      type: Boolean,
      default: true
    },
    // 其他 Element Select 的属性
    selectProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    customerLabel: {
      type: Boolean,
      default: false
    },
    customerLabelKey: {
      default: function _default() {
        return [];
      }
    },
    connectKeyArr: {
      type: Array,
      default: function _default() {
        return [' | '];
      }
    },
    keyLabel: {
      type: String,
      default: 'id'
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      filterText: '',
      isFiltering: false,
      isAllCheck: false
    };
  },
  computed: {
    internalValue: {
      get: function get() {
        var value = this.value;
        if (!value) return value;
        if (Array.isArray(value)) {
          return value.filter(function (e) {
            return e !== undefined && e !== null;
          });
        }
        return value;
      },
      set: function set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    },
    // 筛选后的选项列表（纯计算，无副作用）
    filteredOptions: function filteredOptions() {
      var _this = this;
      if (!this.filterText) {
        return this.options;
      }
      return this.options.filter(function (option) {
        var label = _this.getOptionLabel(option);
        return label.toLowerCase().includes(_this.filterText.toLowerCase());
      });
    },
    // 当前可用的选项列表（筛选时用筛选结果，否则用全部）
    currentOptions: function currentOptions() {
      var options = this.isFiltering ? this.filteredOptions : this.options;
      // 返回非禁用的选项
      return options.filter(function (option) {
        return !option.disabled;
      });
    },
    // 当前选中数量
    currentSelectionCount: function currentSelectionCount() {
      var _this2 = this;
      if (!Array.isArray(this.internalValue)) return 0;
      if (!this.isFiltering) {
        // 非筛选状态下，只计算非禁用选项中被选中的数量
        var allNonDisabledValues = this.options.filter(function (option) {
          return !option.disabled;
        }).map(function (option) {
          return _this2.getOptionValue(option);
        });
        return this.internalValue.filter(function (value) {
          return allNonDisabledValues.includes(value);
        }).length;
      }

      // 筛选状态下只计算当前显示的非禁用选项中被选中的数量
      var filteredValues = this.filteredOptions.filter(function (option) {
        return !option.disabled;
      }).map(function (option) {
        return _this2.getOptionValue(option);
      });
      return this.internalValue.filter(function (value) {
        return filteredValues.includes(value);
      }).length;
    },
    checkState: function checkState() {
      var _this3 = this;
      var state = {
        checked: false,
        indeterminate: false
      };
      if (!Array.isArray(this.internalValue)) {
        return state;
      }

      // currentOptions 已经过滤了禁用选项
      var currentOptionValues = this.currentOptions.map(function (option) {
        return _this3.getOptionValue(option);
      });
      if (currentOptionValues.length === 0) {
        return state;
      }

      // 计算当前非禁用选项列表中被选中的数量
      var selectedCount = this.internalValue.filter(function (value) {
        return currentOptionValues.includes(value);
      }).length;
      state.checked = selectedCount === currentOptionValues.length && currentOptionValues.length > 0;
      state.indeterminate = selectedCount > 0 && selectedCount < currentOptionValues.length;
      this.$nextTick(function () {
        _this3.changeAllCheckStatus(state.checked);
      });
      return state;
    },
    showSelectAll: function showSelectAll() {
      return this.multiple && this.currentOptions.length > 0;
    }
  },
  watch: {
    filterText: function filterText(newVal) {
      var _this4 = this;
      if (!newVal) {
        // 延迟重置筛选状态，确保 DOM 更新完成
        this.$nextTick(function () {
          _this4.isFiltering = false;
        });
      }
    }
  },
  methods: {
    customFilter: function customFilter(query) {
      this.filterText = query;
      // 在这里更新筛选状态，而不是在计算属性中
      this.isFiltering = !!query;
    },
    changeVisible: function changeVisible(v) {
      if (!v) {
        this.filterText = '';
      }
    },
    changeAllCheckStatus: function changeAllCheckStatus(status) {
      this.isAllCheck = status;
    },
    // 获取选项值（支持自定义字段名）
    getOptionValue: function getOptionValue(option) {
      if (_typeof(option) === 'object' && option !== null) {
        // 如果有指定的valueKey属性，则返回该属性值
        if (option[this.valueKey] !== undefined) {
          return option[this.valueKey];
        }
        // 如果有keyLabel属性（默认为id），可以用作唯一标识
        if (option[this.keyLabel] !== undefined) {
          return option[this.keyLabel];
        }
        // 如果都没有，可以返回一个基于对象内容的字符串标识
        return JSON.stringify(option);
      }
      return option;
    },
    // 获取选项标签（支持自定义字段名）
    getOptionLabel: function getOptionLabel(option) {
      var _this5 = this;
      if (_typeof(option) === 'object' && option !== null) {
        if (!this.customerLabel) {
          return option[this.labelKey] !== undefined ? option[this.labelKey] : option[this.valueKey] !== undefined ? String(option[this.valueKey]) : String(option);
        } else {
          var label = '';
          this.customerLabelKey.forEach(function (key, index) {
            label += option[key] ? option[key] + (_this5.connectKeyArr[index] || '') : '';
          });
          console.log(label);
          return label;
        }
      }
      return String(option);
    },
    handleSelectAll: function handleSelectAll(checked) {
      var _this6 = this;
      // 全选时只考虑非禁用的选项
      var currentOptionValues = this.currentOptions.filter(function (option) {
        return !option.disabled;
      }).map(function (option) {
        return _this6.getOptionValue(option);
      });
      if (checked) {
        // 全选当前显示的非禁用选项
        var newValues = [];
        if (this.isFiltering) {
          // 筛选状态下：保留原有选中项，加上当前筛选出的所有非禁用选项（去重）
          var existingValues = Array.isArray(this.internalValue) ? this.internalValue : [];
          newValues = _toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), _toConsumableArray(currentOptionValues))));
        } else {
          // 非筛选状态下：选择全部非禁用选项
          newValues = _toConsumableArray(currentOptionValues);
        }
        this.$emit('input', newValues);
        this.$emit('change', newValues, this.currentOptions.filter(function (option) {
          return !option.disabled;
        }));
      } else {
        // 取消全选当前显示的选项
        var _newValues = [];
        if (this.isFiltering) {
          // 筛选状态下：只移除当前筛选出的非禁用选项，保留其他选项
          _newValues = Array.isArray(this.internalValue) ? this.internalValue.filter(function (value) {
            return !currentOptionValues.includes(value);
          }) : [];
        } else {
          // 非筛选状态下：清空所有
          _newValues = [];
        }
        this.$emit('input', _newValues);
        this.$emit('change', _newValues, []);
      }
    },
    handleChange: function handleChange(value) {
      console.log(value, '选中值');
      this.$emit('change', value);
    },
    handleClear: function handleClear() {
      this.filterText = '';
      this.isFiltering = false;
    }
  }
};